import { PropType } from 'vue'
import { useSizeProp } from '@zoryn/hooks'
import type { GridTreeOption } from './grid-tree-option'
import type { GridFooterMethod, GridTreeOptions } from './types'

export const gridTreeProps = {
  size: useSizeProp,
  options: {
    type: Object as PropType<GridTreeOption | GridTreeOptions>,
    default: () => ({}),
  },
  editable: {
    type: Boolean as PropType<boolean>,
    default: undefined,
  },
  height: [String, Number],
  autoHeight: {
    type: Boolean,
    default: true,
  },
  border: {
    type: Boolean,
    default: true,
  },
  showFooter: {
    type: Boolean,
    default: false,
  },
  footerData: Array as PropType<Array<Record<string, unknown>>>,
  footerMethod: Function as PropType<GridFooterMethod>,
}
